export const DEVICE_APP_ID = 'DEVICE_APP_ID';
export const PC_USER_ID = 'pc_user_id';
